// This WebAudioEncoderImpl is needed for Safari for now, because Safari doesn't
// yet support the WebCodecs audio API.
import { EventEmitter } from 'eventemitter3';
import { OpusEncoderWrapper } from './OpusEncoderWrapper';
import { WebAudioRecorder } from './WebAudioRecorder';
export class WebAudioEncoderImpl {
    emitter;
    webAudioRecorder;
    opusEncoderWrapper;
    broadcasting = false;
    constructor() {
        this.emitter = new EventEmitter();
    }
    async start(audioTrack) {
        console.log('WebAudioEncoderImpl::start()', audioTrack);
        this.opusEncoderWrapper = new OpusEncoderWrapper();
        this.opusEncoderWrapper.on('encodedAudioData', (encodedAudioData) => {
            this.emitter.emit('audioData', encodedAudioData);
        });
        await this.opusEncoderWrapper.start();
        this.webAudioRecorder = new WebAudioRecorder();
        this.webAudioRecorder.on('data', (timestampMicros, samples) => {
            if (!this.broadcasting) {
                return;
            }
            this.opusEncoderWrapper?.encode(timestampMicros, samples);
        });
        await this.webAudioRecorder.start(audioTrack);
    }
    startBroadcasting() {
        this.broadcasting = true;
    }
    stopBroadcasting() {
        this.broadcasting = false;
    }
    async stop() {
        console.log('WebAudioEncoderImpl stop');
        await this.webAudioRecorder?.stop();
        await this.opusEncoderWrapper?.stop();
    }
}
